/** A pickable option that has a name, a logo and a reason it might not be
 * pickable — and nothing else. The select grid renders these without knowing
 * they happen to be fund issuers, or where the logo was fetched from. */
export interface LogoOption {
  id: string;
  name: string;
  logoUrl?: string;
  /** False renders the option greyed out and unselectable. */
  canBeContacted: boolean;
}

export interface Option<T> {
  id: T;
  label: string;
}

/**
 * FA's ASSET-group sector codes, as they come back on `security.allocations`.
 * Verified against the live security set: FA uses exactly SA, GA, NR, RR,
 * ALTER and CASH — nothing else. `ALL` is our own sentinel for "no filter" and
 * is never compared against a code.
 *
 * These are only the types we *offer* as filter options. Codes outside this
 * list (CASH today, anything FA adds tomorrow) must still count towards the
 * unfiltered option, so `useRelevantIssuers` deliberately does not treat this
 * enum as an allowlist.
 */
export enum VALID_ASSET_TYPES {
  ALL = "NO_SELECTED_ASSET",
  SWEDEN_STOCKS = "SA",
  GLOBAL_STOCKS = "GA",
  ALTERNATIVE = "ALTER",
  NOMINAL = "NR",
  REALA = "RR",
}

export enum HOLDINGS_SETTINGS {
  ALL = "All",
  PORTFOLIO = "Portfolio",
}
